import { render, staticRenderFns } from "./DataSourceManager.vue?vue&type=template&id=22038818&scoped=true&"
import script from "./DataSourceManager.vue?vue&type=script&lang=js&"
export * from "./DataSourceManager.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceManager.vue?vue&type=style&index=0&id=22038818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22038818",
  null
  
)

export default component.exports